import { resolveEmailFlow, useEmailChannelConnector } from '@/features/connectors/email';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetConnectorFlowsQuery, useGetConnectorInstancesQuery } from '@/services/endpoints/workspace-connectors';

export const useEmailSendingDomainConnector = () => {
  const workspace = useWorkspace();
  const channel = useEmailChannelConnector();

  const {
    data: connectorFlows,
    isLoading: isFlowsLoading,
    isError: isFlowsError,
  } = useGetConnectorFlowsQuery({ workspaceId: workspace.id, queryParams: { showUserJourney: true } }, { skip: !workspace.id });
  // Same query useEmailChannelConnector runs (deduplicated by RTK Query), read here for its error.
  const { isError: isInstancesError } = useGetConnectorInstancesQuery({ workspaceId: workspace.id }, { skip: !workspace.id });

  // Scoped to the email connector: the short names the discovery sync writes ("Domain Insert", …)
  // are not unique across connectors.
  const connectorId = channel.connector?.id;
  const domainInsertFlow = resolveEmailFlow(connectorFlows, connectorId, 'domainInsert');
  const domainInfoFlow = resolveEmailFlow(connectorFlows, connectorId, 'domainInfo');
  const domainDeleteFlow = resolveEmailFlow(connectorFlows, connectorId, 'domainDelete');
  const connectorInstanceId = channel.instanceId;

  const isLoading = isFlowsLoading || channel.isLoading;
  const isError = isFlowsError || isInstancesError;
  const isInsertReady = !!domainInsertFlow?.id && !!connectorInstanceId;
  const isInfoReady = !!domainInfoFlow?.id && !!connectorInstanceId;
  const isDeleteReady = !!domainDeleteFlow?.id && !!connectorInstanceId;

  return {
    /** @deprecated Use insertFlowId */
    flowId: domainInsertFlow?.id,
    insertFlowId: domainInsertFlow?.id,
    infoFlowId: domainInfoFlow?.id,
    deleteFlowId: domainDeleteFlow?.id,
    connectorInstanceId,
    connectorId,
    isLoading,
    isError,
    isReady: isInsertReady,
    isInsertReady,
    isInfoReady,
    isDeleteReady,
    missingInsertFlow: !isLoading && !domainInsertFlow,
    missingInfoFlow: !isLoading && !domainInfoFlow,
    missingDeleteFlow: !isLoading && !domainDeleteFlow,
    missingFlow: !isLoading && !domainInsertFlow,
    missingInstance: !isLoading && !!domainInsertFlow && !connectorInstanceId,
  };
};
